import React, { useState } from 'react';
import { User, Mail, Phone, Building2, Save, Key } from 'lucide-react';

const API = 'https://talentflow-backend-production-09dd.up.railway.app/api';

export default function ProfilePage({ user, token, onUpdate }) {
  const [form, setForm] = useState({
    name: user.name || '',
    phone: user.phone || '',
    companyName: user.companyName || '',
  });
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [msg, setMsg] = useState({ text: '', type: '' });
  const [loading, setLoading] = useState(false);
  const [pwLoading, setPwLoading] = useState(false);

  const showMsg = (text, type = 'success') => { setMsg({ text, type }); setTimeout(() => setMsg({ text: '', type: '' }), 3000); };

  const updateProfile = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const r = await fetch(`${API}/auth/update-profile`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(form)
      });
      const d = await r.json();
      if (d.success) { showMsg('Profile updated!'); onUpdate(d.user); }
      else showMsg(d.message, 'error');
    } catch { showMsg('Error!', 'error'); }
    setLoading(false);
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.newPassword !== pwForm.confirmPassword) return showMsg('Passwords do not match!', 'error');
    setPwLoading(true);
    try {
      const r = await fetch(`${API}/auth/change-password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword })
      });
      const d = await r.json();
      if (d.success) { showMsg('Password changed!'); setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' }); }
      else showMsg(d.message, 'error');
    } catch { showMsg('Error!', 'error'); }
    setPwLoading(false);
  };

  const inp = { width: '100%', padding: '10px 14px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#1e293b', fontSize: '14px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };

  const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981'];
  const avatarColor = colors[user.name?.charCodeAt(0) % colors.length];

  return (
    <div style={{ maxWidth: '760px', margin: '0 auto' }}>
      {msg.text && <div style={{ padding: '12px 16px', borderRadius: '10px', marginBottom: '20px', fontSize: '14px', background: msg.type === 'error' ? '#fee2e2' : '#dcfce7', color: msg.type === 'error' ? '#dc2626' : '#16a34a' }}>{msg.text}</div>}

      {/* Profile header */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '28px', border: '1px solid #e2e8f0', marginBottom: '20px', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '24px' }}>
          <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: avatarColor, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '800', fontSize: '28px' }}>
            {user.name?.charAt(0).toUpperCase()}
          </div>
          <div>
            <h2 style={{ color: '#1e293b', fontSize: '20px', fontWeight: '700', margin: '0 0 4px' }}>{user.name}</h2>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <span style={{ padding: '3px 10px', background: '#ede9fe', color: '#6366f1', borderRadius: '20px', fontSize: '12px', fontWeight: '600', textTransform: 'capitalize' }}>{user.role}</span>
              <span style={{ color: '#94a3b8', fontSize: '13px' }}>{user.email}</span>
            </div>
          </div>
        </div>

        <form onSubmit={updateProfile}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={{ color: '#64748b', fontSize: '11px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}><User size={12}/> FULL NAME</label>
              <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" style={inp}/>
            </div>
            <div>
              <label style={{ color: '#64748b', fontSize: '11px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}><Phone size={12}/> PHONE</label>
              <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="9876543210" style={inp}/>
            </div>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#64748b', fontSize: '11px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '6px' }}><Building2 size={12}/> COMPANY NAME</label>
            <input value={form.companyName} onChange={e => setForm({ ...form, companyName: e.target.value })} placeholder="TechCorp India" style={inp}/>
          </div>
          <div style={{ padding: '12px 16px', background: '#f8fafc', borderRadius: '8px', marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Mail size={14} color="#94a3b8"/>
              <span style={{ color: '#64748b', fontSize: '13px' }}>{user.email}</span>
              <span style={{ color: '#94a3b8', fontSize: '11px' }}>(Email cannot be changed)</span>
            </div>
          </div>
          <button type="submit" disabled={loading} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '11px 24px', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', fontFamily: 'inherit' }}>
            <Save size={15}/> {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>

      {/* Change Password */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '28px', border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
        <h3 style={{ color: '#1e293b', fontSize: '16px', fontWeight: '600', margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: '8px' }}><Key size={16} color="#6366f1"/> Change Password</h3>
        <form onSubmit={changePassword}>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ color: '#64748b', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '6px' }}>CURRENT PASSWORD</label>
            <input type="password" value={pwForm.currentPassword} onChange={e => setPwForm({ ...pwForm, currentPassword: e.target.value })} placeholder="Current password" style={inp} required/>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '20px' }}>
            <div>
              <label style={{ color: '#64748b', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '6px' }}>NEW PASSWORD</label>
              <input type="password" value={pwForm.newPassword} onChange={e => setPwForm({ ...pwForm, newPassword: e.target.value })} placeholder="Min 6 characters" style={inp} required/>
            </div>
            <div>
              <label style={{ color: '#64748b', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '6px' }}>CONFIRM PASSWORD</label>
              <input type="password" value={pwForm.confirmPassword} onChange={e => setPwForm({ ...pwForm, confirmPassword: e.target.value })} placeholder="Confirm password" style={inp} required/>
            </div>
          </div>
          <button type="submit" disabled={pwLoading} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '11px 24px', background: '#1e293b', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600', fontFamily: 'inherit' }}>
            <Key size={15}/> {pwLoading ? 'Changing...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
